import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Config, getConfig } from '../../api/configsApi';
import { AppThunk } from '../../app/store';

const initialState = null as (null | Config);

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig: (_, action: PayloadAction<Config | null>) => {
      return action.payload;
    }
  }
});

export const updateUserConfig = (id: string): AppThunk => async (dispatch, getState) => {
  try {
    const config = getState().config;
    if (config?.id === id) {
      const result = await getConfig(id);
      dispatch(setConfig(result));
    }
  }
  catch (err: any) {
    console.log(err.toString());
  }
};

export const { setConfig } = configSlice.actions;

export default configSlice.reducer;
